import { render, staticRenderFns } from "./v-fagforening-for-mig.vue?vue&type=template&id=63f17c4d&"
import script from "./v-fagforening-for-mig.vue?vue&type=script&lang=js&"
export * from "./v-fagforening-for-mig.vue?vue&type=script&lang=js&"
import style0 from "./v-fagforening-for-mig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports